<template>
  <div @click="view = !view" class="flex flex-row items-center text-white hover:bg-white hover:text-default cursor-pointer px-4 py-2 rounded-full" >
    <div class="rounded-full h-2 w-2 m-2" :class="[this.colors[setName.color]]" ></div>
    <p>{{ setName.title }}</p>
  </div>
  <DatasetViewer v-if="view" />
</template>

<script>
import DatasetViewer from '@/components/DatasetViewer'

export default {
  name: 'Dataset',
  components: {
    DatasetViewer
  },
  data: function () {
    return {
      colors: [
        'bg-graph-red',
        'bg-graph-orange',
        'bg-graph-orange-yellow-1',
        'bg-graph-orange-yellow-2',
        'bg-graph-yellow',
        'bg-graph-green',
        'bg-graph-turquoise',
        'bg-graph-isthisblue',
        'bg-graph-dark-blue',
        'bg-graph-blue'
      ],
      view: false
    }
  },
  props: {
    setName: {
      type: String,
      required: true
    },
    color: {
      type: Number,
      required: true
    }
  },
  created: function () {
    console.log(this.setName)
  }
}
</script>

<style scoped>

</style>
